import { T } from 'lib/tolgee'

const TOLGEE_PREFIX = 'GenerateWinninAIReportUseCaseModal'

function ErrorContent() {
  return (
    <div>
      <p className="GenerateWinninAIReportUseCaseModal-description">
        <T keyName={`${TOLGEE_PREFIX}-defaultDescription`}>
          Não conseguimos identificar o tipo de report que você deseja gerar. Por favor, tente novamente.
        </T>
      </p>
    </div>
  )
}

export default ErrorContent
